import React, {ReactNode, useMemo} from 'react';
import {getClassNames} from '../../utils';

import './Icon.css';
import withTheme from '../../hocs/withTheme';
import { iconsMap } from './types';

/** Semantic vector graphics. */

type IconProps = {
    size?: number | string;
    type: string;
    color?: string;
    ariaLabel?: string;
    component?: ReactNode;
    className?: string;
    onClick?: () => void;
    role?: string;
    tabIndex?: number;
}

function Icon({
    size = 18, type = '', color = '', ariaLabel = '', component = null, className: classNameProp = '', onClick = () => {}, ...rest
}: IconProps) {
    const Icon = iconsMap.get(type) || component;
    const iconProps = useMemo(() => ({
        fill: 'currentColor',
        width: '1em',
        height: '1em',
    }), []);
    const className = getClassNames(classNameProp, 'Icon', { [`Icon-${type}`]: type });

    if (!Icon) return null;

    return (
        <i
            {...rest}
            className={className}
            aria-label={ariaLabel}
            style={{ fontSize: `${size}px`, color }}
            onClick={onClick}
        >
            <Icon {...iconProps}></Icon>
        </i>
    );
}

export default withTheme(Icon);
